import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { nonEmptyString } from './non-empty-string'

/** Date formatted as `YYYYMMDD`, `null` when unknown. */
const compactDate = () =>
  z.nullable(
    z.string().check(z.regex(/^\d{8}$/, 'must be formatted as YYYYMMDD')),
  )

const userBehaviorSchema = z.discriminatedUnion('login_status', [
  z.strictObject({
    login_status: z.literal('logged_out'),
  }),
  z.strictObject({
    login_status: z.literal('logged_in'),
    user_type: z.enum(['new', 'returning']),
    account_creation_date: compactDate(),
    number_of_orders: z.number().check(z.gte(0)),
    last_order_date: compactDate(),
    customer_lifetime_value: z.number(),
  }),
])

/** Pushed by `setUserContext` and `setAnonymousUserContext`. */
export const userDataSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('user_data'),
  session_context: z.strictObject({
    bm_visitor_id: nonEmptyString(),
    bm_session_id: nonEmptyString(),
    app_version: nonEmptyString(),
    currency: nonEmptyString(),
    market: nonEmptyString(),
    locale: nonEmptyString(),
  }),
  // Logged-in users only
  user_info: z.optional(
    z.strictObject({
      // Hashed email, apps pass `''` when the user store has none
      email_address: z.string(),
    }),
  ),
  // Logged-in users only
  user_ids: z.optional(
    z.strictObject({
      bm_account_id: z.optional(z.number()),
      user_id: z.number(),
      bm_user_id: z.optional(nonEmptyString()),
    }),
  ),
  user_behavior: userBehaviorSchema,
  // Omitted when no experiment is running
  experiment_context: z.optional(
    z
      .array(
        z.strictObject({
          experiment_id: nonEmptyString(),
          variant: nonEmptyString(),
        }),
      )
      .check(z.minLength(1)),
  ),
})
